import { Href, MaterialIcon, VSpace } from "~/shared/ui"

import cssModule from "./index.module.scss"
import { useUserInfo } from "~/domain/user-session"

export type ContactsProps = {
	phone: string
	//localPhone: string;
	email: string
}

export function Contacts({ phone, /*localPhone,*/ email }: ContactsProps) {

	const userInfo = useUserInfo()

	return (
		<div className={cssModule.contactsRoot}>
			<div className="pb-[1rem]">
				<h3 className="mt-[2rem] p-0">
					<Href style={{ color: "rgb(30, 67, 128)", textDecoration: "none" }}
						  className={cssModule.hoveredUrl}
						  href="/main/institute-contacts">
						<MaterialIcon name="contacts" />
						<span className="underline" style={{ fontSize: "inherit"}}>
						Контакты институтов
						</span>
					</Href>
				</h3>
				<VSpace size={1} />
				<h3 className="p-0 pb-[0.5rem]">
					{!userInfo
						? "Тех. поддержка системы:"
						: <Href style={{ color: "rgb(30, 67, 128)", textDecoration: "none" }}
								className={cssModule.hoveredUrl}
								href="/bugreport/user">
							<MaterialIcon name="bug_report" style={{ fontSize: "1.8rem", marginLeft: "-0.2rem" }} />
							<span className="underline" style={{ fontSize: "inherit", marginLeft: "-0.1rem"}}>
							Тех. поддержка системы:
							</span>
						</Href>}
				</h3>
				<div className={cssModule.contactItem}>
					<span>Телефон: </span>
					<a href={`tel:${phone}`}>{phone}</a>
				</div>
				{/*localPhone && <div css={contactItemCss}><span>Местный телефон: </span><span>{localPhone}</span></div>*/}
				<div className={cssModule.contactItem}>
					<span>E-mail: </span>
					<a href={`mailto:${email}`}>{email}</a>
				</div>
			</div>
		</div>
	)
}
